/**
 * Intercom-style dimension tokens for FloatingConcierge.
 * See docs/concierge-widget-ux-spec.md for research rationale.
 */

/** Collapsed launcher — 56px (h-14 w-14). */
export const FLOATING_LAUNCHER_SIZE_CLASS = "h-14 w-14";

/** Compact open panel width (desktop/tablet). */
export const FLOATING_PANEL_WIDTH_CLASS = "md:w-[min(400px,calc(100vw-32px))]";

/** Tall/expanded open panel width — wider carousels, still ≤480px. */
export const FLOATING_PANEL_WIDTH_EXPANDED_CLASS =
  "md:w-[min(480px,calc(100vw-32px))]";

/** Compact panel height — industry ~600px / 85dvh band. */
export const FLOATING_PANEL_HEIGHT_CLASS =
  "h-[min(600px,calc(100dvh-env(safe-area-inset-bottom)-32px))]";

/** Tall panel height — extra room for recommendation carousels. */
export const FLOATING_PANEL_HEIGHT_EXPANDED_CLASS =
  "h-[min(720px,calc(100dvh-env(safe-area-inset-bottom)-32px))]";

/** Mobile width — full bleed minus 16px margins each side. */
export const FLOATING_PANEL_MOBILE_WIDTH_CLASS = "w-[calc(100vw-32px)]";
